import React, { useState, useEffect, useRef, useCallback } from 'react';
import { toPng } from 'html-to-image';
import { useAuth } from '../contexts/AuthContext';
import { plannerService } from '../services/academicPlannerService';
import TaskFormModal from '../components/academic-planner/TaskFormModal';
import TaskCard from '../components/academic-planner/TaskCard';




async function exportAsImage(rootEl, filename, setExporting) {
  if (!rootEl) return;
  try {
    setExporting(true);
    const clone = rootEl.cloneNode(true);
    const host  = document.createElement('div');
    host.style.cssText = 'position:fixed;inset:0;z-index:999999;pointer-events:none;opacity:0;background:transparent';

    clone.style.maxWidth  = 'none';
    clone.style.width     = 'auto';
    clone.style.overflow  = 'visible';
    clone.style.direction = 'rtl';
    clone.style.color     = '#ffffff';
    clone.style.background = '#081423';

    host.appendChild(clone);
    document.body.appendChild(host);

    const cloneScroll = clone.querySelector('[data-export-scroll="1"]');
    if (cloneScroll) {
      cloneScroll.style.overflow = 'visible';
      cloneScroll.style.maxWidth = 'none';
      cloneScroll.style.width    = 'auto';
    }

    await new Promise((r) => requestAnimationFrame(r));
    if (document.fonts?.ready) await document.fonts.ready;
    await Promise.all(
      Array.from(clone.querySelectorAll('img')).map(
        (img) => new Promise((res) => { if (img.complete) return res(); img.onload = res; img.onerror = res; })
      )
    );
    await new Promise((r) => requestAnimationFrame(r));

    const target = cloneScroll || clone;
    const fullW  = Math.ceil(Math.max(target.scrollWidth, clone.scrollWidth, clone.getBoundingClientRect().width));
    const fullH  = Math.ceil(Math.max(target.scrollHeight, clone.scrollHeight, clone.getBoundingClientRect().height));

    clone.style.width = `${fullW}px`;
    if (cloneScroll) cloneScroll.style.width = `${fullW}px`;

    await new Promise((r) => requestAnimationFrame(r));

    const px     = fullW >= 1400 ? 1.5 : 2;
    const dataUrl = await toPng(clone, {
      cacheBust:       true,
      pixelRatio:      px,
      backgroundColor: '#081423',
      width:  fullW,
      height: fullH,
      style:  { width: `${fullW}px`, height: `${fullH}px`, direction: 'rtl', color: '#ffffff', background: '#081423' },
    });

    host.remove();

    const link      = document.createElement('a');
    link.href       = dataUrl;
    link.download   = filename;
    link.click();
  } catch {
    alert('فشل التصدير، حاول مرة أخرى.');
  } finally {
    setExporting(false);
  }
}




const MONTHS_AR = ['يناير','فبراير','مارس','أبريل','مايو','يونيو',
                   'يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'];
const DAYS_AR   = ['الأحد','الاثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'];
const QUOTES    = [
  'العلم نور يضيء درب من يطلبه بجد وإخلاص',
  'النجاح ليس نهاية الطريق، بل بداية مسيرة أجمل',
  'لكل درجة تبذل لها جهداً قيمةٌ لا تُنسى',
];
const TYPE_COLORS   = { واجب: '#28E3DA', مشروع: '#F1C267', اختبار: '#FA8686' };
const STATUS_COLORS = { 'لم يبدأ': 'rgba(255,255,255,0.35)', جاري: '#60A5FA', مكتمل: '#5FCC9C' };

const DEFAULT_SETTINGS = {
  semester_name:  'الفصل الدراسي الثاني',
  semester_start: '',
  num_weeks:      16,
  general_notes:  '',
  my_quote:       '',
  subjects:       [],
};




function addDays(d, n) { const r = new Date(d); r.setDate(r.getDate() + n); return r; }
function toKey(d)       { return d.toISOString().split('T')[0]; }
function fmtShort(d)    { return `${d.getDate()} ${MONTHS_AR[d.getMonth()].slice(0,3)}`; }
function fmtFull(d)     { return `${DAYS_AR[d.getDay()]}، ${d.getDate()} ${MONTHS_AR[d.getMonth()]} ${d.getFullYear()}`; }

function formatDue(due) {
  if (!due) return null;
  try {
    const d = new Date(due.includes('T') ? due : `${due}T12:00:00`);
    return `${d.getDate()} ${MONTHS_AR[d.getMonth()]}`;
  } catch { return null; }
}

function daysUntil(due) {
  if (!due) return null;
  const today = new Date(); today.setHours(0,0,0,0);
  const d = new Date(due.includes('T') ? due : `${due}T12:00:00`);
  return Math.ceil((d - today) / 86400000);
}


function getWeekStart(semesterStart, idx) {
  const s   = new Date(semesterStart + 'T12:00:00');
  const off = s.getDay() === 0 ? 0 : 7 - s.getDay();
  return addDays(s, off + idx * 7);
}




const cardStyle = {
  background:
    'linear-gradient(0deg, rgba(255,255,255,0.02), rgba(255,255,255,0.02)), ' +
    'radial-gradient(92.12% 184.55% at 50% -55%, rgba(40,227,218,0.1) 0%, rgba(40,227,218,0) 100%), ' +
    'rgb(8,20,35)',
  border: '1px solid rgba(40,227,218,0.15)',
  borderRadius: '14px',
};




const Ico = {
  Home:    ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  Calendar:({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  CheckSq: ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
  Target:  ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
  Star:    ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill={color} stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  Clock:   ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  Clipboard:({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>,
  Inbox:   ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>,
  Trophy:  ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/></svg>,
  Lock:    ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  Alert:   ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  Trash:   ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
  Chat:    ({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  BookOpen:({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>,
  FileText:({size=16,color='currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
};

const btnPrimary = {
  background:
    'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40,227,218,0.5) 0%, rgba(40,227,218,0) 100%), rgba(40,227,218,0.25)',
  border: '1px solid rgba(40,227,218,0.3)',
  color: '#fff',
};




function TabBtn({ label, icon, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all whitespace-nowrap flex-shrink-0"
      style={
        active
          ? { background: 'rgba(40,227,218,0.12)', border: '1px solid rgba(40,227,218,0.35)', color: '#28E3DA' }
          : { background: 'transparent', border: '1px solid transparent', color: 'rgba(255,255,255,0.45)' }
      }
    >
      <span>{icon}</span>
      <span>{label}</span>
    </button>
  );
}




function Spinner({ size = 20 }) {
  return (
    <svg className="animate-spin" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="rgba(40,227,218,0.2)" strokeWidth="3" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke="#28E3DA" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}




function DashboardSection({ user, tasks, settings, goals, onGoTasks, onGoGoals }) {
  const today    = new Date();
  const total    = tasks.length;
  const done     = tasks.filter(t => t.status === 'مكتمل').length;
  const inProg   = tasks.filter(t => t.status === 'جاري').length;
  const pending  = tasks.filter(t => t.status === 'لم يبدأ').length;
  const pct      = total > 0 ? Math.round((done / total) * 100) : 0;

  const goalsDone  = goals.filter(g => g.done).length;
  const goalsTotal = goals.length;
  const goalsPct   = goalsTotal > 0 ? Math.round((goalsDone / goalsTotal) * 100) : 0;


  const upcoming = tasks
    .filter(t => t.status !== 'مكتمل' && t.due_date)
    .map(t => ({ ...t, days: daysUntil(t.due_date) }))
    .filter(t => t.days !== null && t.days <= 14)
    .sort((a, b) => a.days - b.days)
    .slice(0, 5);


  const top3 = tasks
    .filter(t => t.status !== 'مكتمل')
    .sort((a, b) => {
      if (a.due_date && b.due_date) return new Date(a.due_date) - new Date(b.due_date);
      return a.due_date ? -1 : 1;
    })
    .slice(0, 3);


  let curWeek = null;
  if (settings.semester_start) {
    for (let i = 0; i < settings.num_weeks; i++) {
      const ws = getWeekStart(settings.semester_start, i);
      const we = addDays(ws, 6);
      if (today >= ws && today <= we) { curWeek = i + 1; break; }
    }
  }

  const quote = QUOTES[today.getDay() % QUOTES.length];

  const statCards = [
    { label: 'إجمالي المهام',  value: total,   color: '#28E3DA' },
    { label: 'لم تبدأ',        value: pending,  color: 'rgba(255,255,255,0.5)' },
    { label: 'جاري التنفيذ',   value: inProg,   color: '#60A5FA' },
    { label: 'مكتملة',         value: done,     color: '#5FCC9C' },
  ];

  return (
    <div className="space-y-5" dir="rtl">
      {             }
      <div
        className="rounded-2xl p-6 relative overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, rgba(40,227,218,0.25) 0%, rgba(40,227,218,0.05) 50%, rgba(8,20,35,0) 100%), rgb(8,20,35)',
          border: '1px solid rgba(40,227,218,0.2)',
        }}
      >
        <div className="relative z-10">
          <p className="text-lg font-bold text-white">
            أهلاً، {user?.displayName || user?.name || user?.username || 'الطالب'}
          </p>
          <p className="text-sm mt-0.5" style={{ color: 'rgba(255,255,255,0.5)' }}>
            {fmtFull(today)}
            {curWeek && (
              <span style={{ color: '#28E3DA' }} className="mr-3 font-semibold">
                · الأسبوع {curWeek} من {settings.semester_name}
              </span>
            )}
          </p>
          <p className="text-sm mt-3 italic" style={{ color: 'rgba(40,227,218,0.8)' }}>
            "{quote}"
          </p>
        </div>
      </div>

      {           }
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {statCards.map((s) => (
          <div key={s.label} className="rounded-xl p-4 text-center" style={cardStyle}>
            <div className="text-3xl font-extrabold" style={{ color: s.color }}>{s.value}</div>
            <div className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)' }}>{s.label}</div>
            {s.label === 'مكتملة' && (
              <div className="mt-2 h-1 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.08)' }}>
                <div
                  className="h-full rounded-full transition-all duration-700"
                  style={{ width: `${pct}%`, background: 'linear-gradient(90deg, #28E3DA, #5FCC9C)' }}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {           }
        <div className="rounded-xl p-5" style={cardStyle}>
          <h3 className="flex items-center gap-2 text-sm font-bold text-white mb-4"><Ico.Star size={13} color="#F1C267"/>أهم ٣ مهام قادمة</h3>
          {top3.length === 0 ? (
            <p className="text-sm text-center py-4" style={{ color: 'rgba(255,255,255,0.3)' }}>
              لا توجد مهام معلقة
            </p>
          ) : (
            <div className="space-y-3">
              {top3.map((t, i) => (
                <div key={t.id} className="flex items-center gap-3">
                  <span
                    className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                    style={{ background: 'rgba(40,227,218,0.15)', color: '#28E3DA' }}
                  >
                    {i + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-white truncate">{t.title}</p>
                    <p className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
                      {t.subject}
                      {t.due_date && ` · ${formatDue(t.due_date)}`}
                    </p>
                  </div>
                  <span
                    className="text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0"
                    style={{
                      background: `${TYPE_COLORS[t.type] || '#28E3DA'}15`,
                      color: TYPE_COLORS[t.type] || '#28E3DA',
                    }}
                  >
                    {t.type}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {                        }
        <div className="rounded-xl p-5" style={cardStyle}>
          <h3 className="flex items-center gap-2 text-sm font-bold text-white mb-4"><Ico.Clock size={13} color="#60A5FA"/>المواعيد خلال ١٤ يوماً</h3>
          {upcoming.length === 0 ? (
            <p className="text-sm text-center py-4" style={{ color: 'rgba(255,255,255,0.3)' }}>
              لا توجد مواعيد قريبة
            </p>
          ) : (
            <div className="space-y-2">
              {upcoming.map((t) => {
                const col = t.days < 0 ? '#FA8686' : t.days <= 3 ? '#F1C267' : 'rgba(255,255,255,0.4)';
                const daysText =
                  t.days < 0  ? 'متأخر!'  :
                  t.days === 0 ? 'اليوم!'  :
                  t.days === 1 ? 'غداً'    : `${t.days} يوم`;
                return (
                  <div
                    key={t.id}
                    className="flex items-center justify-between py-2"
                    style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}
                  >
                    <div className="min-w-0">
                      <p className="text-sm font-semibold text-white truncate">{t.title}</p>
                      <p className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>{t.subject}</p>
                    </div>
                    <span className="text-xs font-bold flex-shrink-0 mr-3" style={{ color: col }}>
                      {daysText}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {                   }
      {goalsTotal > 0 && (
        <div className="rounded-xl p-5" style={cardStyle}>
          <div className="flex items-center justify-between mb-3">
            <h3 className="flex items-center gap-2 text-sm font-bold text-white"><Ico.Target size={13} color="#28E3DA"/>تقدم الأهداف</h3>
            <button
              onClick={onGoGoals}
              className="text-xs font-semibold transition-colors"
              style={{ color: '#28E3DA' }}
            >
              عرض الكل ←
            </button>
          </div>
          <div className="flex items-center gap-3 mb-3">
            <div className="flex-1 h-2 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.07)' }}>
              <div
                className="h-full rounded-full transition-all duration-700"
                style={{ width: `${goalsPct}%`, background: 'linear-gradient(90deg, #28E3DA, #5FCC9C)' }}
              />
            </div>
            <span className="text-xs font-bold flex-shrink-0" style={{ color: '#5FCC9C' }}>
              {goalsDone}/{goalsTotal}
            </span>
          </div>
          <div className="space-y-1.5">
            {goals.slice(0, 4).map((g, i) => (
              <div key={i} className="flex items-center gap-2">
                <span
                  className="w-4 h-4 rounded-full flex-shrink-0 flex items-center justify-center"
                  style={{ background: g.done ? '#5FCC9C' : 'rgba(255,255,255,0.08)', border: g.done ? 'none' : '1.5px solid rgba(255,255,255,0.2)' }}
                >
                  {g.done && (
                    <svg width="8" height="6" viewBox="0 0 10 8" fill="none">
                      <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </span>
                <span
                  className="text-xs truncate"
                  style={{ color: g.done ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.7)', textDecoration: g.done ? 'line-through' : 'none' }}
                >
                  {g.text || `الهدف ${i + 1}`}
                </span>
              </div>
            ))}
            {goalsTotal > 4 && (
              <p className="text-xs" style={{ color: 'rgba(255,255,255,0.25)' }}>+{goalsTotal - 4} أهداف أخرى</p>
            )}
          </div>
        </div>
      )}

      {total === 0 && (
        <div
          className="rounded-xl p-6 text-center"
          style={{ ...cardStyle, border: '1px dashed rgba(40,227,218,0.2)' }}
        >
          <div className="flex justify-center mb-3"><Ico.Clipboard size={36} color="rgba(40,227,218,0.4)"/></div>
          <p className="text-sm font-semibold text-white mb-1">ابدأ بإضافة مهامك</p>
          <p className="text-xs mb-4" style={{ color: 'rgba(255,255,255,0.4)' }}>
            أضف واجباتك ومشاريعك واختباراتك لتتابع تقدمك
          </p>
          <button onClick={onGoTasks} className="px-5 py-2 rounded-xl text-sm font-bold transition-all" style={btnPrimary}>
            إضافة مهمة
          </button>
        </div>
      )}
    </div>
  );
}




function CalendarSection({ settings, onSettingsChange, tasks, weekNotes, onWeekNoteChange }) {
  const today      = new Date(); today.setHours(0,0,0,0);
  const semStart   = settings.semester_start;
  const nWeeks     = settings.num_weeks;
  const inputStyle = {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
  };
  const exportRef  = useRef(null);
  const [exporting, setExporting] = useState(false);


  const tasksByDate = {};
  tasks.forEach((t) => {
    if (t.due_date) {
      const key = t.due_date.split('T')[0];
      if (!tasksByDate[key]) tasksByDate[key] = [];
      tasksByDate[key].push(t);
    }
  });


  const tasksByWeek = {};
  tasks.forEach((t) => {
    if (t.week_num) {
      if (!tasksByWeek[t.week_num]) tasksByWeek[t.week_num] = [];
      tasksByWeek[t.week_num].push(t);
    }
  });

  return (
    <div className="space-y-5" dir="rtl">
      {                  }
      <div className="rounded-xl p-4 flex flex-wrap gap-4 items-center" style={cardStyle}>
        <div className="flex items-center gap-2">
          <label className="text-xs font-semibold" style={{ color: 'rgba(255,255,255,0.5)' }}>بداية الفصل:</label>
          <input
            type="date"
            value={settings.semester_start}
            onChange={(e) => onSettingsChange({ ...settings, semester_start: e.target.value })}
            className="h-8 px-2 rounded-lg text-xs text-white outline-none"
            style={inputStyle}
          />
        </div>
        <div className="flex items-center gap-2">
          <label className="text-xs font-semibold" style={{ color: 'rgba(255,255,255,0.5)' }}>الأسابيع:</label>
          <input
            type="number"
            min={8} max={26}
            value={settings.num_weeks}
            onChange={(e) => onSettingsChange({ ...settings, num_weeks: Math.min(26, Math.max(8, parseInt(e.target.value) || 16)) })}
            className="w-16 h-8 px-2 rounded-lg text-xs text-white outline-none text-center"
            style={inputStyle}
          />
        </div>
        <div className="flex items-center gap-2 flex-1 min-w-[200px]">
          <label className="text-xs font-semibold whitespace-nowrap" style={{ color: 'rgba(255,255,255,0.5)' }}>اسم الفصل:</label>
          <input
            type="text"
            value={settings.semester_name}
            onChange={(e) => onSettingsChange({ ...settings, semester_name: e.target.value })}
            className="flex-1 h-8 px-2 rounded-lg text-xs text-white outline-none"
            style={inputStyle}
            dir="rtl"
          />
        </div>
        {            }
        <div className="flex gap-3 flex-wrap">
          {[
            { color: '#28E3DA', label: 'واجب' },
            { color: '#F1C267', label: 'مشروع' },
            { color: '#FA8686', label: 'اختبار' },
          ].map(({ color, label }) => (
            <div key={label} className="flex items-center gap-1.5">
              <div className="w-2 h-2 rounded-full" style={{ background: color }} />
              <span className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>{label}</span>
            </div>
          ))}
        </div>
        {                            }
        {semStart && (
          <button
            onClick={() => exportAsImage(exportRef.current, 'calendar.png', setExporting)}
            disabled={exporting}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-bold transition-all disabled:opacity-50 mr-auto"
            style={{ background: 'rgba(40,227,218,0.1)', border: '1px solid rgba(40,227,218,0.25)', color: '#28E3DA' }}
          >
            {exporting ? <Spinner size={12} /> : (
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            )}
            {exporting ? 'جاري...' : 'حفظ كصورة'}
          </button>
        )}
      </div>

      {!semStart ? (
        <div className="text-center py-10 rounded-xl" style={cardStyle}>
          <div className="flex justify-center mb-3"><Ico.Calendar size={36} color="rgba(255,255,255,0.2)"/></div>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>
            حدد تاريخ بداية الفصل في الأعلى لعرض التقويم
          </p>
        </div>
      ) : (
        <div ref={exportRef} className="relative rounded-2xl overflow-hidden border" style={{ background: '#081423', borderColor: 'rgba(40,227,218,0.12)' }}>
          <div className="overflow-x-auto" data-export-scroll="1">
          <table className="w-full border-collapse" style={{ minWidth: 700 }}>
            <thead>
              <tr>
                <th
                  className="text-right px-3 py-2.5 text-xs font-bold w-24"
                  style={{ background: 'rgba(40,227,218,0.08)', color: '#28E3DA', border: '1px solid rgba(40,227,218,0.12)' }}
                >
                  الأسبوع
                </th>
                {['الأحد','الاثنين','الثلاثاء','الأربعاء','الخميس'].map((d) => (
                  <th
                    key={d}
                    className="text-center px-2 py-2.5 text-xs font-bold"
                    style={{ background: 'rgba(40,227,218,0.08)', color: 'rgba(255,255,255,0.6)', border: '1px solid rgba(40,227,218,0.12)', minWidth: 90 }}
                  >
                    {d}
                  </th>
                ))}
                <th
                  className="text-right px-3 py-2.5 text-xs font-bold"
                  style={{ background: 'rgba(40,227,218,0.08)', color: 'rgba(255,255,255,0.6)', border: '1px solid rgba(40,227,218,0.12)', width: 160 }}
                >
                  ملاحظات
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: nWeeks }, (_, i) => {
                const ws       = getWeekStart(semStart, i);
                const we       = addDays(ws, 4);
                const isCur    = today >= ws && today <= addDays(ws, 6);
                const wkTasks  = tasksByWeek[i + 1] || [];
                const rowBg    = isCur
                  ? 'rgba(40,227,218,0.05)'
                  : i % 2 === 0 ? 'rgba(255,255,255,0.01)' : 'transparent';

                return (
                  <tr key={i} style={{ background: rowBg }}>
                    {                }
                    <td
                      className="px-3 py-2 align-top"
                      style={{ border: '1px solid rgba(255,255,255,0.06)', verticalAlign: 'top' }}
                    >
                      <div className="text-xs font-bold" style={{ color: isCur ? '#28E3DA' : 'rgba(255,255,255,0.6)' }}>
                        أسبوع {i + 1}
                        {isCur && <span className="mr-1 text-xs" style={{ color: '#28E3DA' }}>◀</span>}
                      </div>
                      <div className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.3)' }}>
                        {fmtShort(ws)} – {fmtShort(we)}
                      </div>
                      {                                                   }
                      {wkTasks.length > 0 && (() => {
                        const counts = {};
                        const titles = {};
                        wkTasks.forEach((t) => {
                          const key = t.type || '—';
                          counts[key] = (counts[key] || 0) + 1;
                          titles[key] = titles[key] ? titles[key] + '، ' + t.title : t.title;
                        });
                        return (
                          <div className="mt-1.5 flex flex-wrap gap-0.5">
                            {Object.entries(counts).map(([type, count]) => {
                              const col = TYPE_COLORS[type] || '#28E3DA';
                              return (
                                <span
                                  key={type}
                                  className="inline-flex items-center gap-0.5 text-xs px-1.5 py-0.5 rounded-full font-bold"
                                  style={{
                                    background: `${col}20`,
                                    color: col,
                                    border: `1px solid ${col}40`,
                                    fontSize: 10,
                                  }}
                                  title={titles[type]}
                                >
                                  {type}
                                  {count > 1 && (
                                    <span
                                      className="inline-flex items-center justify-center rounded-full font-extrabold"
                                      style={{
                                        background: col,
                                        color: '#081423',
                                        fontSize: 9,
                                        minWidth: 14,
                                        height: 14,
                                        padding: '0 3px',
                                        marginRight: 1,
                                      }}
                                    >
                                      ×{count}
                                    </span>
                                  )}
                                </span>
                              );
                            })}
                          </div>
                        );
                      })()}
                    </td>

                    {                  }
                    {Array.from({ length: 5 }, (_, d) => {
                      const day    = addDays(ws, d);
                      const key    = toKey(day);
                      const isToday = toKey(today) === key;
                      const dayTasks = tasksByDate[key] || [];

                      return (
                        <td
                          key={d}
                          className="px-2 py-2 align-top"
                          style={{ border: '1px solid rgba(255,255,255,0.06)', verticalAlign: 'top', minHeight: 70 }}
                        >
                          <div
                            className="text-xs font-semibold mb-1"
                            style={{
                              color: isToday ? '#28E3DA' : 'rgba(255,255,255,0.35)',
                              ...(isToday && {
                                background: 'rgba(40,227,218,0.15)',
                                borderRadius: '4px',
                                padding: '1px 4px',
                                display: 'inline-block',
                              }),
                            }}
                          >
                            {day.getDate()}
                          </div>
                          <div className="space-y-0.5">
                            {dayTasks.map((t) => (
                              <div
                                key={t.id}
                                className="text-xs px-1.5 py-0.5 rounded truncate"
                                style={{
                                  background: `${TYPE_COLORS[t.type] || '#28E3DA'}18`,
                                  color: TYPE_COLORS[t.type] || '#28E3DA',
                                  border: `1px solid ${TYPE_COLORS[t.type] || '#28E3DA'}30`,
                                }}
                                title={`${t.type}${t.subject ? ' · ' + t.subject : ''}: ${t.title}`}
                              >
                                {t.title}
                              </div>
                            ))}
                          </div>
                        </td>
                      );
                    })}

                    {           }
                    <td
                      className="px-2 py-1 align-top"
                      style={{ border: '1px solid rgba(255,255,255,0.06)' }}
                    >
                      <textarea
                        value={weekNotes[i + 1] || ''}
                        onChange={(e) => onWeekNoteChange(i + 1, e.target.value)}
                        placeholder="ملاحظات..."
                        rows={3}
                        className="w-full text-xs resize-none outline-none bg-transparent"
                        style={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.6 }}
                        dir="rtl"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </div>
      )}
    </div>
  );
}




function TasksSection({ tasks, settings, onAdd, onCycleStatus, onEdit, onDelete }) {
  const [typeFilter,    setTypeFilter]   = useState('الكل');
  const [statusFilter,  setStatusFilter] = useState('الكل');
  const [subjectFilter, setSubjectFilter] = useState('الكل');
  const [exporting,     setExporting]    = useState(false);
  const exportRef = useRef(null);

  const subjects = ['الكل', ...Array.from(new Set(tasks.map(t => t.subject).filter(Boolean)))];

  const filtered = tasks.filter((t) => {
    if (typeFilter   !== 'الكل' && t.type   !== typeFilter)   return false;
    if (statusFilter !== 'الكل' && t.status !== statusFilter) return false;
    if (subjectFilter !== 'الكل' && t.subject !== subjectFilter) return false;
    return true;
  }).sort((a, b) => {
    if (a.status === 'مكتمل' && b.status !== 'مكتمل') return 1;
    if (a.status !== 'مكتمل' && b.status === 'مكتمل') return -1;
    if (a.due_date && b.due_date) return new Date(a.due_date) - new Date(b.due_date);
    return a.due_date ? -1 : 1;
  });

  function Filters({ label, options, value, onChange, colorMap }) {
    return (
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>{label}:</span>
        {options.map((opt) => {
          const active = value === opt;
          const col    = colorMap?.[opt] || '#28E3DA';
          return (
            <button
              key={opt}
              onClick={() => onChange(opt)}
              className="px-3 py-1 rounded-full text-xs font-semibold transition-all"
              style={
                active
                  ? { background: `${col}20`, border: `1px solid ${col}50`, color: col }
                  : { background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.4)' }
              }
            >
              {opt}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="space-y-4" dir="rtl">
      {            }
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-base font-bold text-white">المهام الدراسية</h2>
          <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.4)' }}>
            {tasks.length} مهمة · {tasks.filter(t => t.status === 'مكتمل').length} مكتملة
          </p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {tasks.length > 0 && (
            <button
              onClick={() => exportAsImage(exportRef.current, 'tasks-table.png', setExporting)}
              disabled={exporting}
              className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-bold transition-all disabled:opacity-50"
              style={{
                background: 'rgba(241,194,103,0.12)',
                border: '1px solid rgba(241,194,103,0.3)',
                color: '#F1C267',
              }}
              title="حفظ الجدول كصورة"
            >
              {exporting ? (
                <Spinner size={14} />
              ) : (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="7 10 12 15 17 10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
              )}
              <span className="hidden sm:inline">{exporting ? 'جاري...' : 'حفظ كصورة'}</span>
            </button>
          )}
          <button onClick={onAdd} className="px-4 py-2 rounded-xl text-sm font-bold transition-all" style={btnPrimary}>
            <span className="hidden sm:inline">+ إضافة مهمة</span>
            <span className="sm:hidden">+</span>
          </button>
        </div>
      </div>

      {             }
      <div className="rounded-xl p-4 space-y-3" style={cardStyle}>
        <Filters
          label="النوع"
          options={['الكل', 'واجب', 'مشروع', 'اختبار']}
          value={typeFilter}
          onChange={setTypeFilter}
          colorMap={TYPE_COLORS}
        />
        <Filters
          label="الحالة"
          options={['الكل', 'لم يبدأ', 'جاري', 'مكتمل']}
          value={statusFilter}
          onChange={setStatusFilter}
          colorMap={STATUS_COLORS}
        />
        {subjects.length > 1 && (
          <Filters
            label="المادة"
            options={subjects}
            value={subjectFilter}
            onChange={setSubjectFilter}
          />
        )}
      </div>

      {               }
      {filtered.length === 0 ? (
        <div className="text-center py-10 rounded-xl" style={{ ...cardStyle, border: '1px dashed rgba(255,255,255,0.1)' }}>
          <div className="flex justify-center mb-3"><Ico.Inbox size={32} color="rgba(255,255,255,0.2)"/></div>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>
            {tasks.length === 0 ? 'لا توجد مهام بعد' : 'لا توجد مهام بهذه الفلاتر'}
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {filtered.map((task) => (
            <TaskCard
              key={task.id}
              task={task}
              onCycleStatus={onCycleStatus}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}

      {                                                       }
      <div style={{ position: 'absolute', left: '-9999px', top: 0, zIndex: -1 }}>
        <div
          ref={exportRef}
          dir="rtl"
          style={{
            background: '#081423',
            color: '#fff',
            padding: '28px 32px',
            fontFamily: "'Segoe UI', Tahoma, Arial, sans-serif",
            minWidth: 900,
            borderRadius: 16,
          }}
        >
          {            }
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, paddingBottom: 16, borderBottom: '1px solid rgba(40,227,218,0.2)' }}>
            <div>
              <div style={{ fontSize: 20, fontWeight: 800, color: '#fff' }}>المهام الدراسية</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', marginTop: 4 }}>
                {settings.semester_name} · {tasks.length} مهمة
              </div>
            </div>
            <div style={{ display: 'flex', gap: 14 }}>
              {[
                { n: tasks.filter(t => t.status === 'لم يبدأ').length,  l: 'لم تبدأ',  c: 'rgba(255,255,255,0.5)' },
                { n: tasks.filter(t => t.status === 'جاري').length,      l: 'جاري',     c: '#60A5FA'              },
                { n: tasks.filter(t => t.status === 'مكتمل').length,     l: 'مكتملة',   c: '#5FCC9C'              },
              ].map(({ n, l, c }) => (
                <div key={l} style={{ textAlign: 'center', background: 'rgba(255,255,255,0.05)', borderRadius: 10, padding: '8px 16px' }}>
                  <div style={{ fontSize: 22, fontWeight: 800, color: c }}>{n}</div>
                  <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>{l}</div>
                </div>
              ))}
            </div>
          </div>
          {           }
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr>
                {['#', 'العنوان', 'المادة', 'النوع', 'الأولوية', 'الحالة', 'تاريخ التسليم', 'الأسبوع', 'الوصف'].map((h, i) => (
                  <th key={h} style={{
                    background: 'rgba(40,227,218,0.1)',
                    color: '#28E3DA',
                    padding: '8px 10px',
                    textAlign: 'right',
                    fontWeight: 700,
                    border: '1px solid rgba(40,227,218,0.15)',
                    width: i === 0 ? 28 : i === 7 ? 60 : undefined,
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...tasks]
                .sort((a, b) => {
                  if (a.status === 'مكتمل' && b.status !== 'مكتمل') return 1;
                  if (a.status !== 'مكتمل' && b.status === 'مكتمل') return -1;
                  if (a.due_date && b.due_date) return new Date(a.due_date) - new Date(b.due_date);
                  return a.due_date ? -1 : 1;
                })
                .map((t, i) => {
                  const tCol = TYPE_COLORS[t.type]     || '#28E3DA';
                  const sCol = STATUS_COLORS[t.status] || 'rgba(255,255,255,0.35)';
                  const bg   = i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent';
                  const dStr = t.due_date ? formatDue(t.due_date) : '—';
                  return (
                    <tr key={t.id} style={{ background: bg }}>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.3)', textAlign: 'center' }}>{i + 1}</td>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)', fontWeight: 700, color: t.status === 'مكتمل' ? 'rgba(255,255,255,0.35)' : '#fff' }}>{t.title || '—'}</td>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.55)' }}>{t.subject || '—'}</td>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)' }}>
                        <span style={{ background: `${tCol}22`, color: tCol, padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{t.type || '—'}</span>
                      </td>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.55)' }}>{t.priority || '—'}</td>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)' }}>
                        <span style={{ background: `${sCol}22`, color: sCol, padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{t.status || '—'}</span>
                      </td>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.55)', whiteSpace: 'nowrap' }}>{dStr}</td>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.4)', textAlign: 'center' }}>{t.week_num || '—'}</td>
                      <td style={{ padding: '7px 10px', border: '1px solid rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.4)', fontSize: 11 }}>{t.description || '—'}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {            }
          <div style={{ marginTop: 14, fontSize: 10, color: 'rgba(255,255,255,0.25)', textAlign: 'center' }}>
            منصة هِمّة · الخطة الأكاديمية · {new Date().toLocaleDateString('ar-SA-u-nu-latn', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>
      </div>
    </div>
  );
}




function GoalsSection({ settings, goals, onSettingsChange, onGoalsChange }) {
  const [newSubject, setNewSubject] = useState('');

  const doneCount = goals.filter(g => g.done).length;
  const total     = goals.length;
  const pct       = total > 0 ? Math.round((doneCount / total) * 100) : 0;

  function addGoal()        { onGoalsChange([...goals, { text: '', done: false }]); }
  function removeGoal(i)    { const g = [...goals]; g.splice(i, 1); onGoalsChange(g); }
  function updateText(i, v) { const g = [...goals]; g[i] = { ...g[i], text: v }; onGoalsChange(g); }
  function toggleDone(i)    { const g = [...goals]; g[i] = { ...g[i], done: !g[i].done }; onGoalsChange(g); }

  function addSubject() {
    const v = newSubject.trim();
    if (v && !settings.subjects.includes(v))
      onSettingsChange({ ...settings, subjects: [...settings.subjects, v] });
    setNewSubject('');
  }
  function removeSubject(i) {
    const s = [...settings.subjects]; s.splice(i, 1);
    onSettingsChange({ ...settings, subjects: s });
  }

  const pillColors = ['#28E3DA', '#F1C267', '#FA8686', '#5FCC9C', '#C4B5FD'];
  const taStyle = {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '12px', outline: 'none', color: '#fff',
    resize: 'vertical', lineHeight: '1.8', fontFamily: 'inherit',
  };

  return (
    <div className="space-y-5" dir="rtl">

      {                                   }
      <div className="rounded-2xl p-5" style={cardStyle}>

        {            }
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="flex items-center gap-2 text-sm font-bold text-white"><Ico.Target size={14} color="#28E3DA"/>أهداف الفصل الدراسي</h3>
            <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.4)' }}>
              {total === 0 ? 'أضف أهدافك للفصل الدراسي' : `${doneCount} من ${total} هدف محقق`}
            </p>
          </div>
          {total > 0 && (
            <div
              className="flex items-center justify-center w-14 h-14 rounded-full flex-shrink-0"
              style={{
                background: `conic-gradient(#5FCC9C ${pct * 3.6}deg, rgba(255,255,255,0.07) 0deg)`,
                padding: 3,
              }}
            >
              <div
                className="w-full h-full rounded-full flex items-center justify-center"
                style={{ background: '#081423' }}
              >
                <span className="text-xs font-extrabold" style={{ color: '#5FCC9C' }}>{pct}%</span>
              </div>
            </div>
          )}
        </div>

        {                  }
        {total > 0 && (
          <div className="mb-5">
            <div className="h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.07)' }}>
              <div
                className="h-full rounded-full transition-all duration-700"
                style={{ width: `${pct}%`, background: 'linear-gradient(90deg, #28E3DA, #5FCC9C)' }}
              />
            </div>
          </div>
        )}

        {                 }
        {total === 0 && (
          <div className="text-center py-8 mb-4" style={{ borderTop: '1px dashed rgba(255,255,255,0.08)' }}>
            <div className="flex justify-center mb-3"><Ico.Trophy size={36} color="rgba(241,194,103,0.4)"/></div>
            <p className="text-sm font-semibold text-white mb-1">ما في أهداف بعد</p>
            <p className="text-xs" style={{ color: 'rgba(255,255,255,0.35)' }}>
              حدد أهدافك للفصل وتابع تقدمك
            </p>
          </div>
        )}

        {                }
        <div className="space-y-2 mb-4">
          {goals.map((g, i) => (
            <div
              key={i}
              className="flex items-center gap-3 rounded-xl px-3 py-2.5 group transition-all"
              style={{
                background: g.done ? 'rgba(95,204,156,0.06)' : 'rgba(255,255,255,0.03)',
                border: g.done ? '1px solid rgba(95,204,156,0.2)' : '1px solid rgba(255,255,255,0.07)',
              }}
            >
              {                   }
              <button
                onClick={() => toggleDone(i)}
                className="flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all"
                style={{
                  borderColor: g.done ? '#5FCC9C' : 'rgba(255,255,255,0.25)',
                  background:  g.done ? '#5FCC9C' : 'transparent',
                }}
                title={g.done ? 'إلغاء التحقيق' : 'تحديد كمحقق'}
              >
                {g.done && (
                  <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                    <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>

              {                  }
              <span
                className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold"
                style={{
                  background: g.done ? 'rgba(95,204,156,0.15)' : 'rgba(255,255,255,0.07)',
                  color: g.done ? '#5FCC9C' : 'rgba(255,255,255,0.3)',
                  fontSize: 10,
                }}
              >
                {i + 1}
              </span>

              {                }
              <input
                type="text"
                value={g.text}
                onChange={(e) => updateText(i, e.target.value)}
                placeholder={`الهدف ${i + 1}...`}
                className="flex-1 bg-transparent outline-none text-sm transition-all"
                style={{
                  color:          g.done ? 'rgba(255,255,255,0.35)' : '#fff',
                  textDecoration: g.done ? 'line-through' : 'none',
                }}
                dir="rtl"
              />

              {            }
              <button
                onClick={() => removeGoal(i)}
                className="flex-shrink-0 w-6 h-6 rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all"
                style={{ color: 'rgba(255,255,255,0.3)' }}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#FA8686'; e.currentTarget.style.background = 'rgba(250,134,134,0.1)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.3)'; e.currentTarget.style.background = 'transparent'; }}
              >
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                  <path d="M2 3H10M4.5 3V2H7.5V3M5 5.5V9M7 5.5V9M3 3L3.5 10H8.5L9 3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          ))}
        </div>

        <button
          onClick={addGoal}
          className="flex items-center gap-2 text-xs font-semibold px-4 py-2 rounded-xl transition-all"
          style={{ color: '#28E3DA', background: 'rgba(40,227,218,0.07)', border: '1px solid rgba(40,227,218,0.18)' }}
        >
          <span className="text-base leading-none">+</span>
          <span>إضافة هدف</span>
        </button>
      </div>

      {                            }
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

        {           }
        <div className="rounded-2xl p-5" style={cardStyle}>
          <h3 className="flex items-center gap-2 text-sm font-bold text-white mb-3"><Ico.Chat size={13} color="#28E3DA"/>اقتباسي للفصل</h3>
          {settings.my_quote && (
            <div
              className="mb-3 px-4 py-3 rounded-xl text-sm italic leading-relaxed"
              style={{ background: 'rgba(40,227,218,0.06)', borderRight: '3px solid #28E3DA', color: 'rgba(40,227,218,0.9)' }}
              dir="rtl"
            >
              "{settings.my_quote}"
            </div>
          )}
          <textarea
            value={settings.my_quote}
            onChange={(e) => onSettingsChange({ ...settings, my_quote: e.target.value })}
            placeholder="اكتب اقتباسك أو عبارتك المحفزة..."
            rows={3}
            className="w-full px-3 py-2 text-sm"
            style={taStyle}
            dir="rtl"
          />
        </div>

        {              }
        <div className="rounded-2xl p-5" style={cardStyle}>
          <h3 className="flex items-center gap-2 text-sm font-bold text-white mb-3"><Ico.BookOpen size={13} color="#28E3DA"/>مواد الفصل</h3>
          {settings.subjects.length === 0 ? (
            <p className="text-xs mb-3" style={{ color: 'rgba(255,255,255,0.3)' }}>لم تضف أي مادة بعد</p>
          ) : (
            <div className="flex flex-wrap gap-2 mb-3">
              {settings.subjects.map((s, i) => (
                <button
                  key={i}
                  onClick={() => removeSubject(i)}
                  className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold transition-all hover:opacity-70"
                  style={{
                    background: `${pillColors[i % pillColors.length]}18`,
                    border:     `1px solid ${pillColors[i % pillColors.length]}35`,
                    color:       pillColors[i % pillColors.length],
                  }}
                  title="انقر للحذف"
                >
                  {s}
                  <span style={{ opacity: 0.5, fontSize: 9 }}>✕</span>
                </button>
              ))}
            </div>
          )}
          <div className="flex gap-2">
            <input
              type="text"
              value={newSubject}
              onChange={(e) => setNewSubject(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addSubject(); } }}
              placeholder="اسم المادة..."
              className="flex-1 h-9 px-3 rounded-xl text-sm text-white outline-none"
              style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}
              dir="rtl"
            />
            <button
              onClick={addSubject}
              className="px-4 py-1.5 rounded-xl text-xs font-bold transition-all"
              style={{ background: 'rgba(40,227,218,0.1)', border: '1px solid rgba(40,227,218,0.2)', color: '#28E3DA' }}
            >
              إضافة
            </button>
          </div>
        </div>
      </div>

      {                         }
      <div className="rounded-2xl p-5" style={cardStyle}>
        <h3 className="flex items-center gap-2 text-sm font-bold text-white mb-3"><Ico.FileText size={13} color="#28E3DA"/>ملاحظات عامة</h3>
        <textarea
          value={settings.general_notes}
          onChange={(e) => onSettingsChange({ ...settings, general_notes: e.target.value })}
          placeholder="سجّل هنا مواعيد مهمة، نصائح، أو أي شيء يخص فصلك الدراسي..."
          rows={5}
          className="w-full px-3 py-2.5 text-sm"
          style={{ ...taStyle, minHeight: 120 }}
          dir="rtl"
        />
      </div>
    </div>
  );
}




export default function AcademicPlannerPage() {
  const { user, booted } = useAuth() || {};

  const [tab,       setTab]       = useState('dashboard');
  const [tasks,     setTasks]     = useState([]);
  const [goals,     setGoals]     = useState([]);
  const [settings,  setSettings]  = useState(DEFAULT_SETTINGS);
  const [weekNotes, setWeekNotes] = useState({});

  const [loading,      setLoading]      = useState(true);
  const [loadError,    setLoadError]    = useState('');
  const [saving,       setSaving]       = useState(false);


  const [modalOpen,  setModalOpen]  = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [taskSaving,  setTaskSaving]  = useState(false);


  const [deleteId, setDeleteId] = useState(null);


  const settingsTimer = useRef(null);
  const goalsTimer    = useRef(null);
  const weekNoteTimers = useRef({});


  useEffect(() => {
    if (!booted) return;
    if (!user)   { setLoading(false); return; }

    async function load() {
      try {
        setLoading(true);
        const data = await plannerService.getAll();

        setTasks(data.tasks || []);

        setGoals((data.goals || []).map(g =>
          typeof g === 'string' ? { text: g, done: false } : g
        ));
        setWeekNotes(data.week_notes || {});

        if (data.settings) {
          setSettings({
            semester_name:  data.settings.semester_name  || DEFAULT_SETTINGS.semester_name,
            semester_start: data.settings.semester_start
              ? (typeof data.settings.semester_start === 'string'
                  ? data.settings.semester_start.split('T')[0]
                  : new Date(data.settings.semester_start).toISOString().split('T')[0])
              : '',
            num_weeks:      data.settings.num_weeks      || 16,
            general_notes:  data.settings.general_notes  || '',
            my_quote:       data.settings.my_quote        || '',
            subjects:       data.settings.subjects       || [],
          });
        }

        plannerService.checkDeadlines().catch(() => {});
      } catch (e) {
        if (e.status === 401) setLoadError('auth');
        else setLoadError(e.message || 'خطأ في تحميل البيانات');
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [user, booted]);


  const saveSettings = useCallback((next) => {
    clearTimeout(settingsTimer.current);
    settingsTimer.current = setTimeout(async () => {
      try {
        setSaving(true);
        await plannerService.saveSettings(next);
      } catch {              } finally {
        setSaving(false);
      }
    }, 1200);
  }, []);

  const handleSettingsChange = useCallback((next) => {
    setSettings(next);
    saveSettings(next);
  }, [saveSettings]);


  const saveGoals = useCallback((next) => {
    clearTimeout(goalsTimer.current);
    goalsTimer.current = setTimeout(async () => {
      try {
        setSaving(true);
        await plannerService.saveGoals(next.filter(g => (g.text || '').trim()));
      } catch {              } finally {
        setSaving(false);
      }
    }, 1200);
  }, []);

  const handleGoalsChange = useCallback((next) => {
    setGoals(next);
    saveGoals(next);
  }, [saveGoals]);


  const handleWeekNoteChange = useCallback((weekNum, note) => {
    setWeekNotes((prev) => ({ ...prev, [weekNum]: note }));
    clearTimeout(weekNoteTimers.current[weekNum]);
    weekNoteTimers.current[weekNum] = setTimeout(async () => {
      try { await plannerService.saveWeekNote(weekNum, note); } catch {              }
    }, 1500);
  }, []);


  async function handleSaveTask(form) {
    try {
      setTaskSaving(true);
      if (editingTask) {
        const res = await plannerService.updateTask(editingTask.id, form);
        setTasks((prev) => prev.map((t) => t.id === editingTask.id ? { ...t, ...res.task } : t));
      } else {
        const res = await plannerService.createTask(form);
        setTasks((prev) => [...prev, res.task]);
      }
      setModalOpen(false);
      setEditingTask(null);
    } catch (e) {
      alert(e.message || 'حدث خطأ أثناء الحفظ');
    } finally {
      setTaskSaving(false);
    }
  }

  async function handleCycleStatus(id) {
    const task  = tasks.find((t) => t.id === id);
    if (!task) return;
    const cycle  = ['لم يبدأ', 'جاري', 'مكتمل'];
    const next   = cycle[(cycle.indexOf(task.status) + 1) % 3];

    setTasks((prev) => prev.map((t) => t.id === id ? { ...t, status: next } : t));
    try {
      await plannerService.updateTask(id, { status: next });
    } catch {

      setTasks((prev) => prev.map((t) => t.id === id ? { ...t, status: task.status } : t));
    }
  }

  function openEdit(task) {
    setEditingTask(task);
    setModalOpen(true);
  }

  function openAdd() {
    setEditingTask(null);
    setModalOpen(true);
  }

  async function handleDelete(id) {
    setDeleteId(id);
  }

  async function confirmDelete() {
    if (!deleteId) return;

    const prev = [...tasks];
    setTasks((t) => t.filter((x) => x.id !== deleteId));
    setDeleteId(null);
    try {
      await plannerService.deleteTask(deleteId);
    } catch {
      setTasks(prev);
    }
  }






  if (!booted) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Spinner size={32} />
      </div>
    );
  }


  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-6" dir="rtl">
        <div
          className="rounded-2xl p-8 max-w-sm w-full"
          style={cardStyle}
        >
          <div className="flex justify-center mb-4"><Ico.Lock size={40} color="rgba(255,255,255,0.25)"/></div>
          <h2 className="text-lg font-bold text-white mb-2">تسجيل الدخول مطلوب</h2>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>
            سجّل دخولك للوصول إلى مخططك الأكاديمي وحفظ بياناتك
          </p>
        </div>
      </div>
    );
  }


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center space-y-3">
          <Spinner size={32} />
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>جارٍ تحميل مخططك...</p>
        </div>
      </div>
    );
  }


  if (loadError && loadError !== 'auth') {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-6" dir="rtl">
        <div className="rounded-2xl p-8 max-w-sm w-full" style={cardStyle}>
          <div className="flex justify-center mb-4"><Ico.Alert size={40} color="#FA8686"/></div>
          <p className="text-sm" style={{ color: '#FA8686' }}>{loadError}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 rounded-xl text-sm font-bold"
            style={btnPrimary}
          >
            إعادة المحاولة
          </button>
        </div>
      </div>
    );
  }

  const tabs = [
    { id: 'dashboard', label: 'لوحة المتابعة', icon: <Ico.Home     size={15}/> },
    { id: 'calendar',  label: 'التقويم',        icon: <Ico.Calendar size={15}/> },
    { id: 'tasks',     label: 'المهام',          icon: <Ico.CheckSq  size={15}/> },
    { id: 'goals',     label: 'الأهداف',         icon: <Ico.Target   size={15}/> },
  ];

  return (
    <div className="space-y-6 p-4 md:p-6" dir="rtl">
      {                 }
      <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-xl font-extrabold text-white leading-tight">
              الخطة الأكاديمية
            </h1>
            <p className="text-sm mt-2 leading-relaxed" style={{ color: 'rgba(255,255,255,0.45)' }}>
              {settings.semester_name} · تقويم وإدارة المهام الجامعية
            </p>
          </div>
        {saving && (
          <div className="flex items-center gap-2 text-xs" style={{ color: '#28E3DA' }}>
            <Spinner size={14} />
            <span>جارٍ الحفظ...</span>
          </div>
        )}
      </div>

      {                          }
      {(() => {
        const today = new Date(); today.setHours(0,0,0,0);
        const overdue = tasks.filter(t => {
          if (t.status === 'مكتمل' || !t.due_date) return false;
          const d = new Date(t.due_date.includes('T') ? t.due_date : `${t.due_date}T12:00:00`);
          d.setHours(0,0,0,0);
          return d < today;
        });
        if (!overdue.length) return null;
        return (
          <div
            className="flex items-start gap-3 rounded-2xl px-4 py-3"
            style={{
              background: 'linear-gradient(135deg, rgba(250,134,134,0.12) 0%, rgba(250,134,134,0.04) 100%)',
              border: '1px solid rgba(250,134,134,0.35)',
            }}
          >
            <div className="flex-shrink-0 mt-0.5">
              <Ico.Alert size={18} color="#FA8686" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold" style={{ color: '#FA8686' }}>
                {overdue.length === 1 ? 'مهمة متأخرة' : `${overdue.length} مهام متأخرة`} — لم يتم التسليم
              </p>
              <div className="mt-1.5 flex flex-wrap gap-1.5">
                {overdue.slice(0, 4).map(t => (
                  <button
                    key={t.id}
                    onClick={() => setTab('tasks')}
                    className="text-xs px-2.5 py-1 rounded-full transition-all"
                    style={{
                      background: 'rgba(250,134,134,0.12)',
                      border: '1px solid rgba(250,134,134,0.3)',
                      color: 'rgba(255,255,255,0.75)',
                      maxWidth: '180px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {t.type}: {t.title}
                  </button>
                ))}
                {overdue.length > 4 && (
                  <span className="text-xs px-2.5 py-1 rounded-full" style={{ background: 'rgba(250,134,134,0.08)', border: '1px solid rgba(250,134,134,0.2)', color: 'rgba(255,255,255,0.4)' }}>
                    +{overdue.length - 4} أخرى
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      })()}

      {                    }
      <div
        className="flex gap-2 overflow-x-auto pb-1"
        style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {tabs.map((t) => (
          <TabBtn
            key={t.id}
            label={t.label}
            icon={t.icon}
            active={tab === t.id}
            onClick={() => setTab(t.id)}
          />
        ))}
      </div>

      {             }
      {tab === 'dashboard' && (
        <DashboardSection
          user={user}
          tasks={tasks}
          settings={settings}
          goals={goals}
          onGoTasks={() => { setTab('tasks'); openAdd(); }}
          onGoGoals={() => setTab('goals')}
        />
      )}
      {tab === 'calendar' && (
        <CalendarSection
          settings={settings}
          onSettingsChange={handleSettingsChange}
          tasks={tasks}
          weekNotes={weekNotes}
          onWeekNoteChange={handleWeekNoteChange}
        />
      )}
      {tab === 'tasks' && (
        <TasksSection
          tasks={tasks}
          settings={settings}
          onAdd={openAdd}
          onCycleStatus={handleCycleStatus}
          onEdit={openEdit}
          onDelete={handleDelete}
        />
      )}
      {tab === 'goals' && (
        <GoalsSection
          settings={settings}
          goals={goals}
          onSettingsChange={handleSettingsChange}
          onGoalsChange={handleGoalsChange}
        />
      )}

      {                     }
      <TaskFormModal
        isOpen={modalOpen}
        onClose={() => { setModalOpen(false); setEditingTask(null); }}
        onSave={handleSaveTask}
        initial={editingTask}
        numWeeks={settings.num_weeks}
        subjects={settings.subjects || []}
        loading={taskSaving}
      />

      {                               }
      {deleteId && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}
          dir="rtl"
        >
          <div
            className="rounded-2xl p-6 max-w-xs w-full text-center"
            style={cardStyle}
          >
            <div className="flex justify-center mb-3"><Ico.Trash size={28} color="#FA8686"/></div>
            <p className="text-sm font-bold text-white mb-1">حذف المهمة؟</p>
            <p className="text-xs mb-5" style={{ color: 'rgba(255,255,255,0.4)' }}>
              لا يمكن التراجع عن هذا الإجراء
            </p>
            <div className="flex gap-3">
              <button
                onClick={confirmDelete}
                className="flex-1 py-2 rounded-xl text-sm font-bold"
                style={{ background: 'rgba(250,134,134,0.15)', border: '1px solid rgba(250,134,134,0.3)', color: '#FA8686' }}
              >
                حذف
              </button>
              <button
                onClick={() => setDeleteId(null)}
                className="flex-1 py-2 rounded-xl text-sm font-semibold"
                style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.7)' }}
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
